var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58094 15.6962L9.3105 15.6709L19.6501 5.36709C19.8514 5.16456 20.0065 4.93249 20.1155 4.67089C20.2245 4.40928 20.2791 4.13502 20.2791 3.8481C20.2791 3.56118 20.2245 3.28692 20.1155 3.02532C20.0065 2.76371 19.8514 2.53164 19.6501 2.32911L17.9394 0.607594C17.5369 0.202532 17.0338 0 16.43 0C15.8262 0 15.3231 0.202532 14.9206 0.607594L4.58094 10.9114V15.6962ZM16.43 2.12658L18.1407 3.8481L16.43 5.5443L14.7193 3.8481L16.43 2.12658ZM6.7193 11.8228L13.1847 5.36709L14.8954 7.06329L8.43 13.519H6.7193V11.8228ZM2.41742 20H17.4614C18.0484 20 18.5516 19.789 18.9709 19.3671C19.3902 18.9451 19.5998 18.4388 19.5998 17.8481V8.48101L17.4614 10.6329V17.8481H5.81364C5.79687 17.8481 5.78429 17.8481 5.77591 17.8481C5.76752 17.8481 5.75494 17.8481 5.73817 17.8481C5.7214 17.8481 5.70463 17.8481 5.68786 17.8481C5.67109 17.8481 5.64593 17.8481 5.61239 17.8481H2.41742V2.73418H9.76333L11.9269 0.556961H2.41742C1.83042 0.556961 1.32727 0.767933 0.907984 1.18987C0.488696 1.61181 0.279053 2.12658 0.279053 2.73418V17.8481C0.279053 18.4388 0.488696 18.9451 0.907984 19.3671C1.32727 19.789 1.83042 20 2.41742 20Z",
    fill: "#D3B36E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.252d38387fc0646150f05b351a3dcdd0.svg";
export { ForwardRef as ReactComponent };